var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4227_634)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6368 3.82014C21.3174 3.19306 20.8073 2.68299 20.1802 2.36354C19.467 2 18.5337 2 16.6667 2H7.33333C5.46632 2 4.53299 2 3.82014 2.36319C3.19306 2.68264 2.68299 3.19271 2.36354 3.81979C2 4.53299 2 5.46632 2 7.33333V16.6667C2 18.5337 2 19.467 2.36319 20.1799C2.68264 20.8069 3.19271 21.317 3.81979 21.6365C4.53299 21.9997 5.46632 21.9997 7.33299 21.9997H16.6663C18.5333 21.9997 19.4667 21.9997 20.1795 21.6365C20.8066 21.317 21.3167 20.8069 21.6361 20.1799C21.9993 19.4667 21.9993 18.5333 21.9993 16.6667V7.33333C21.9993 5.46632 21.9993 4.53299 21.6361 3.82014H21.6368ZM16.4444 13.1111H13.1111V16.4444C13.1111 17.058 12.6135 17.5556 12 17.5556C11.3865 17.5556 10.8889 17.058 10.8889 16.4444V13.1111H7.55556C6.94201 13.1111 6.44444 12.6135 6.44444 12C6.44444 11.3865 6.94201 10.8889 7.55556 10.8889H10.8889V7.55556C10.8889 6.94201 11.3865 6.44444 12 6.44444C12.6135 6.44444 13.1111 6.94201 13.1111 7.55556V10.8889H16.4444C17.058 10.8889 17.5556 11.3865 17.5556 12C17.5556 12.6135 17.058 13.1111 16.4444 13.1111Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4227_634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSquare);
export default __webpack_public_path__ + "static/media/plus-square.d89e4af0cfa26d1e3711213a029cb765.svg";
export { ForwardRef as ReactComponent };